import { postRejectOrAcceptParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAcceptOrRejectRecievedImages/postAcceptOrRejectRecievedImages.type';
import { postAcceptOrRejectRecievedImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAcceptOrRejectRecievedImages/postAcceptOrRejectRecievedImagesFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const postAcceptOrRejectRecievedImagesOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  postRejectOrAcceptParamsType
> => ({
  mutationKey: ['POST_ACCEPT_OR_REJECT_RECIEVED_IMAGES_OPTIONS'],
  mutationFn: ({ damaged_id, data, id }) =>
    postAcceptOrRejectRecievedImagesFunction({ damaged_id, id, data }),
});
